import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/wahlen-gewinnen/wahlkampf")({
  head: () => ({
    meta: [
      { title: "Parteikampagnen – creategy" },
      { name: "robots", content: "noindex" },
    ],
    links: [{ rel: "canonical", href: "https://creategy.de/wahlen-gewinnen/parteikampagnen" }],
  }),
  component: () => <Navigate to="/wahlen-gewinnen/parteikampagnen" replace />,
});
